import { Pipe, PipeTransform } from '@angular/core';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';;

@Pipe({
    name: 'resizeImage',
    standalone: true,
})
export class ResizeImagePipe implements PipeTransform {

    transform(url: string, options: string): string {

        var pattern = new RegExp('https://jmsfiles.blob.core.windows.net/', 'gi');
        const proxyUrl = url?.replace(pattern, ConfigService.environment.imageProxy);
        return `${proxyUrl}?tr=${options}`;

    }

}
